// Vite bakes this at build time. A local `vite build` with no VITE_API_URL
// used to ship http://localhost:3100 into prod (Google login, verify, every
// API call). Production builds now default to the public API; vite.config
// also refuses to emit a localhost bundle.
const FALLBACK = import.meta.env.PROD
  ? "https://api.funnelkeeper.com"
  : "http://localhost:3100";

export const API_BASE = (import.meta.env.VITE_API_URL ?? FALLBACK).replace(/\/$/, "");
